module.exports = __webpack_public_path__ + "assets/exclamation.5140066a.svg";